/*
 *   File : addFaq.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Success Modal
 *   Integrations : 17-01-2022
 *   Version : v1.0
 */

/*import packages*/
import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import $ from 'jquery';
import jsonlint from "jsonlint-mod";


/*import componets*/
import { Input, TextArea } from '../../components/input/index';
import { SecondaryBtn, PrimaryBtn } from '../../components/cta/index';
import { Toast } from '../note';

/*import styles*/
import styles from '../../styles/components/risk.module.scss';

/*import services */
import devconfig from '../../config/config';
import APIPost from '../../services/postApi';

export default function UpdateJSON(props) {

    const [jsonValue, setJsonValue] = useState("");
    const [error, setError] = useState(null);
    const [submitLoader, setSubmitLoader] = useState(false);

    useEffect(() => {
        if (props.data) {
            setJsonValue(props.data.allocation)
        }
    }, [props.data]);


    useEffect(() => {
        var detailModal = document.getElementById('update-json');
        detailModal.addEventListener('hidden.bs.modal', async function () {
            props.close()
        });
    }, [props.close]);

    /*-------edit topic api for quiz ---*/
    const updateInflation = () => {

        try {
            jsonlint.parse(jsonValue); // throws detailed syntax errors with line/column
        } catch (e) {
            setError(`Syntax error: ${e.message}`);
            return;
        }
        setSubmitLoader(true);

        let url = devconfig.admin + "/config/update";

        let data = JSON.stringify({
            type: props.data.type,
            allocation: jsonValue
        })

        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                $('#closebtn').trigger('click');
                props.success();
            } else {
                setError(response.message);
                setSubmitLoader(false);
            }
        })
    }

    return (
        <div className={`${styles.e_json_modal} modal fade`} id="update-json" tabIndex="-1" aria-labelledby="success" aria-hidden="true">
            <div className={`${styles.e_modal_dialog} modal-dialog modal-dialog-centered`}>
                <div className={`modal-content ${styles.e_modal_content}`}>
                    <div className="modal-header">
                        <h6>Edit Min Investment Basket</h6>
                        <button id="closebtn" type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="container px-3">
                        <div className="row">
                            <div className="col-lg-12">
                                <label>Allocation </label>
                                <TextArea placeholder="Topic description" value={jsonValue} valueChange={(value) => { setJsonValue(value) }} type="text" />
                            </div>
                        </div>
                        <div className="row pt-4 mt-2 pb-2">
                            <div className="col-lg-12">
                                <div className="d-flex justify-content-end">
                                    <SecondaryBtn name="Cancel" className={`${styles.e_cancel} e-cancel`} cancel="modal" />
                                    {
                                        jsonValue ?
                                            <PrimaryBtn name="Update" className="e-modal-submit" handleClick={() => updateInflation()} />
                                            :
                                            <PrimaryBtn name="update" className='e-disabled' />
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                error !== null ?
                    <Toast data={error} id="1" type="error" />
                    :
                    null
            }
        </div>
    );
}
